import React from 'react';
import { Link } from 'react-router-dom';

const DesktopNav = ({ categories, subcategories, normalizeText }) => {
  return (
    <nav className="hidden lg:flex items-center justify-center space-x-6 xl:space-x-10 flex-grow px-4" style={{ fontFamily: "'Be Vietnam Pro', sans-serif" }}>
      
      {/* Đèn trang trí với dropdown (Viết hoa chữ cái đầu) */}
      {(() => {
        const denTrangTriCategory = categories.find(cat =>
          cat.category_name.toLowerCase().includes('đèn trang trí')
        );
        const categorySubcategories = denTrangTriCategory ?
          (subcategories[denTrangTriCategory._id] || []) : [];

        if (denTrangTriCategory) {
          return (
            <div key={denTrangTriCategory._id} className="relative group py-2">
              <Link
                to={`/products?category=${denTrangTriCategory._id}`}
                className="text-slate-900 hover:text-yellow-700 text-[13px] xl:text-sm font-semibold transition-colors duration-200 flex items-center whitespace-nowrap"
              >
                Đèn trang trí
                {categorySubcategories.length > 0 && (
                  <svg className="w-3.5 h-3.5 ml-1 transition-transform duration-300 group-hover:rotate-180 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.2} d="M19 9l-7 7-7-7" />
                  </svg>
                )}
              </Link>

              {/* Dropdown Menu - Elegant Slide-down */}
              {categorySubcategories.length > 0 && (
                <div className="absolute top-full left-0 mt-0 w-52 bg-white rounded-b-lg shadow-xl border border-slate-200 py-3 z-[10000] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-1 group-hover:translate-y-0">
                  <Link
                    to={`/products?category=${denTrangTriCategory._id}`}
                    className="block px-5 py-2 text-xs text-slate-800 hover:bg-slate-50 hover:text-yellow-600 font-bold uppercase tracking-wider transition-colors"
                  >
                    Tất cả
                  </Link>
                  <div className="border-t border-slate-100 my-1.5" />
                  {categorySubcategories.map((subcategory) => (
                    <Link
                      key={subcategory._id}
                      to={`/products?subcategory=${subcategory._id}`}
                      className="block px-5 py-2 text-xs text-slate-600 hover:bg-slate-50 hover:text-yellow-600 transition-colors"
                    >
                      {subcategory.subcategory_name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        }
        return null;
      })()}

      {/* Quạt trần (Viết hoa chữ cái đầu) */}
      {(() => {
        const quatTranCategory = categories.find(cat =>
          cat.category_name.toLowerCase().includes('quạt trần')
        );
        const categorySubcategories = quatTranCategory ?
          (subcategories[quatTranCategory._id] || []) : [];

        if (quatTranCategory) {
          if (categorySubcategories.length > 0) {
            return (
              <div key={quatTranCategory._id} className="relative group py-2">
                <Link
                  to={`/products?category=${quatTranCategory._id}`}
                  className="text-slate-900 hover:text-yellow-700 text-[13px] xl:text-sm font-semibold transition-colors duration-200 flex items-center whitespace-nowrap"
                >
                  Quạt trần
                  <svg className="w-3.5 h-3.5 ml-1 transition-transform duration-300 group-hover:rotate-180 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.2} d="M19 9l-7 7-7-7" />
                  </svg>
                </Link>

                {/* Dropdown Menu */}
                <div className="absolute top-full left-0 mt-0 w-52 bg-white rounded-b-lg shadow-xl border border-slate-200 py-3 z-[10000] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-1 group-hover:translate-y-0">
                  <Link
                    to={`/products?category=${quatTranCategory._id}`}
                    className="block px-5 py-2 text-xs text-slate-800 hover:bg-slate-50 hover:text-yellow-600 font-bold uppercase tracking-wider transition-colors"
                  >
                    Tất cả
                  </Link>
                  <div className="border-t border-slate-100 my-1.5" />
                  {categorySubcategories.map((subcategory) => (
                    <Link
                      key={subcategory._id}
                      to={`/products?subcategory=${subcategory._id}`}
                      className="block px-5 py-2 text-xs text-slate-600 hover:bg-slate-50 hover:text-yellow-600 transition-colors"
                    >
                      {subcategory.subcategory_name}
                    </Link>
                  ))}
                </div>
              </div>
            );
          } else {
            return (
              <Link
                key={quatTranCategory._id}
                to={`/products?category=${quatTranCategory._id}`}
                className="text-slate-900 hover:text-yellow-700 text-[13px] xl:text-sm font-semibold transition-colors duration-200 py-2 whitespace-nowrap"
              >
                Quạt trần
              </Link>
            );
          }
        }
        return null;
      })()}

      {/* Sản phẩm Khác với Mega Menu (Viết hoa chữ cái đầu) */}
      <div className="group py-2">
        <span className="text-slate-900 hover:text-yellow-700 text-[13px] xl:text-sm font-semibold transition-colors duration-200 flex items-center cursor-pointer whitespace-nowrap">
          Sản phẩm khác
          <svg className="w-3.5 h-3.5 ml-1 transition-transform duration-300 group-hover:rotate-180 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.2} d="M19 9l-7 7-7-7" />
          </svg>
        </span>

        {/* Mega Menu Dropdown - Aligns with container */}
        {(() => {
          const otherCategories = categories.filter((cat) =>
            !normalizeText(cat.category_name).includes('den trang tri') &&
            !normalizeText(cat.category_name).includes('quat tran')
          );

          if (otherCategories.length === 0) return null;

          return (
            <div className="absolute top-full left-4 right-4 bg-white rounded-b-xl shadow-2xl border border-slate-200 py-8 px-8 z-[10000] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
              <div className="grid grid-cols-12 gap-8">
                {/* Columns of categories (takes 9/12 cols) */}
                <div className={`col-span-9 grid gap-6 ${
                  otherCategories.length <= 3 ? 'grid-cols-3' : 
                  otherCategories.length === 4 ? 'grid-cols-4' : 'grid-cols-5'
                }`}>
                  {otherCategories.map((category) => {
                    const categorySubcategories = subcategories[category._id] || [];
                    return (
                      <div key={category._id} className="space-y-3">
                        <Link
                          to={`/products?category=${category._id}`}
                          className="block text-slate-900 hover:text-yellow-600 font-bold text-xs uppercase tracking-wider border-b border-slate-100 pb-2 transition-colors"
                        >
                          {category.category_name}
                        </Link>
                        {categorySubcategories.length > 0 && (
                          <ul className="space-y-1.5">
                            {categorySubcategories.map((subcategory) => (
                              <li key={subcategory._id}>
                                <Link
                                  to={`/products?subcategory=${subcategory._id}`}
                                  className="text-xs text-slate-500 hover:text-yellow-600 transition-colors duration-150 block py-0.5"
                                >
                                  {subcategory.subcategory_name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Right Promotion Card (takes 3/12 cols) */}
                <div className="col-span-3 border-l border-slate-100 pl-6 flex flex-col justify-between">
                  <div className="space-y-3">
                    <div className="overflow-hidden rounded-lg aspect-video relative group/img shadow-sm border border-slate-100">
                      <img 
                        src="/images/den_hai_dang_lao_cai_den-hai-dang-anh-bia-1.webp" 
                        alt="Các sản phẩm trang trí khác" 
                        className="w-full h-full object-cover transition-transform duration-500 group-hover/img:scale-105"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/images/den_hai_dang_lao_cai_den-hai-dang-logo.webp';
                        }}
                      />
                      <div className="absolute inset-0 bg-black/5"></div>
                    </div>
                    <h4 className="font-bold text-sm text-slate-900">Thiết bị & Phụ kiện cao cấp</h4>
                    <p className="text-xs text-slate-500 leading-relaxed">
                      Khám phá đa dạng các thiết bị điện và đồ trang trí chính hãng chất lượng cao.
                    </p>
                  </div>
                  <Link 
                    to="/products"
                    className="inline-flex items-center justify-center w-full mt-4 py-2 px-4 bg-slate-900 text-white rounded-md text-xs font-bold uppercase tracking-wider hover:bg-yellow-600 hover:text-white transition-all duration-300"
                  >
                    Xem tất cả sản phẩm
                  </Link>
                </div>
              </div>
            </div>
          );
        })()}
      </div>

      {/* Giới thiệu */}
      <Link
        to="/about"
        className="text-slate-900 hover:text-yellow-700 text-[13px] xl:text-sm font-semibold transition-colors duration-200 py-2 whitespace-nowrap"
      >
        Giới thiệu
      </Link>

      {/* Địa chỉ */}
      <Link
        to="/contact"
        className="text-slate-900 hover:text-yellow-700 text-[13px] xl:text-sm font-semibold transition-colors duration-200 py-2 whitespace-nowrap"
      >
        Địa chỉ
      </Link>
    </nav>
  );
};

export default DesktopNav;
